import React from 'react';
import { AcademicCapIcon } from '@heroicons/react/solid';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { cloneDeep, has, keys, map } from 'lodash';
import colors from '@/styles/colors';
import RenderExperience from './RenderExperience';
import { StyledContainer, StyledSectionTitle } from './styles';

export default function ExperienceTimeline({ experienceData }) {
  let leftContent = cloneDeep(experienceData?.filter((item) => item.type === 'lc'));
  if (leftContent?.length) {
    leftContent = leftContent?.sort((a, b) => a.order - b.order);
  }
  const rightContent = experienceData?.filter((item) => item.type === 'rc');
  const mergedData = [...leftContent, ...rightContent];
  const formattedExperience = mergedData.reduce((acc, currItem) => {
    if (currItem.type === 'lc') {
      if (has(acc, ['leftContent'])) {
        if (has(acc.leftContent, [currItem.sectionTitle])) {
          acc.leftContent[currItem.sectionTitle].push(currItem);
        } else {
          acc.leftContent[currItem.sectionTitle] = [currItem];
        }
      } else {
        acc.leftContent = {
          [currItem.sectionTitle]: [currItem],
        };
      }
    } else if (currItem.type === 'rc') {
      if (has(acc, ['rightContent'])) {
        if (has(acc.rightContent, [currItem.sectionTitle])) {
          acc.rightContent[currItem.sectionTitle].push(currItem);
        } else {
          acc.rightContent[currItem.sectionTitle] = [currItem];
        }
      } else {
        acc.rightContent = {
          [currItem.sectionTitle]: [currItem],
        };
      }
    }
    return acc;
  }, {});

  return (
    <StyledContainer id="experience" className="px-4 py-10 mx-auto">
      <div className="flex items-center mb-4">
        <AcademicCapIcon className="w-10 inline-block mr-4" color={colors.lighter} />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">Experience Timeline</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          {map(keys(formattedExperience.leftContent), (k) => (
            <React.Fragment key={k}>
              <StyledSectionTitle className="">{k}</StyledSectionTitle>
              <RenderExperience key={k} data={formattedExperience.leftContent[k]} sectionTitle={k} />
            </React.Fragment>
          ))}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          {map(keys(formattedExperience.rightContent), (k) => (
            <React.Fragment key={k}>
              <StyledSectionTitle className="">{k}</StyledSectionTitle>
              <RenderExperience key={k} data={formattedExperience.rightContent[k]} sectionTitle={k} />
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
    </StyledContainer>
  );
}

ExperienceTimeline.propTypes = {
  experienceData: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
